var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosesearchbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "url(#paint0_linear_873_1363)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23L16 17.6L10.6 23L9 21.4L14.4 16L9 10.6L10.6 9L16 14.4L21.4 9L23 10.6L17.6 16L23 21.4L21.4 23Z",
    fill: "url(#paint1_linear_873_1363)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_873_1363",
    x1: 0,
    y1: 0,
    x2: 38.3371,
    y2: 12.3868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_873_1363",
    x1: 16,
    y1: 9,
    x2: 16,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosesearchbar);
export default __webpack_public_path__ + "static/media/closesearchbar.03be5deed42ff6a769f626a48e84363d.svg";
export { ForwardRef as ReactComponent };